import styled from 'styled-components';

export default styled.div`
  width: ${props => props.thisStyles && props.thisStyles.iconSize ? props.thisStyles.iconSize : '1.6rem'};
  height: ${props => props.thisStyles && props.thisStyles.iconSize ? props.thisStyles.iconSize : '1.6rem'};
  margin: auto;
  position: relative;
`;
